import React from "react";
import { useLocation } from "react-router-dom";

export function Footer() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <footer
      className={`site-footer ${
        isHome ? "footer--home" : "footer--editorial"
      }`}
    >
      <div className="site-footer__inner">
        <h5>mmxxvi jacob marthaller</h5>
        <p>Software engineering, writing, and practical systems work.</p>
      </div>
    </footer>
  );
}
